import React, { useState } from 'react';
import { css } from "emotion";
import { Card, Button } from "@maxmilhas/hangar-components-atomic/public";
import DynamicForm from '../../DynamicForm';

export const cardCss = `
  .category {
    &-buttons {
      display: flex;
      flex-wrap: wrap;
      margin-top: 8px;
      margin-left: -16px;

      > * {
        margin-top: 12px;
        margin-left: 16px;
        flex: 1;
      }

      > button {
        padding: 12px 24px;
      }
    }
  }
`;

const CancellationCategory = ({ category, contextToken, correlationId }) => {
  const { rules, name, description } = category;
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState({ isOpen: false, ruleId: null, title: null, contextToken });
  const isAccordion = description || rules.length > 1;

  return (
    <Card
      title={name}
      isOpen={isOpen}
      onClick={isAccordion ? () => setIsOpen(!isOpen) : () => setModal({ ...modal, isOpen: true, ruleId: rules[0].id, title: rules[0].name })}
      type="accordion"
    >
      <div className={css`${cardCss}`}>
        {description && (
          <div className="category-description">
            {description}
          </div>
        )}

        {rules.length > 0 && (
          <div className="category-buttons">
            {rules.map(rule => (
              <div key={rule.id} className="category-buttons--btn">
                <Button onClick={() => setModal({ ...modal, isOpen: true, ruleId: rule.id, title: rule.name })}>{rule.name}</Button>
              </div>
            ))}
          </div>
        )}
      </div>

      {modal.isOpen && (
        <DynamicForm
          open={modal.isOpen}
          title={modal.title}
          ruleId={modal.ruleId}
          contextToken={modal.contextToken}
          correlationId={correlationId}
          onClose={() => setModal({ ...modal, isOpen: false })}
        />
      )}
    </Card>
  );
};

export default CancellationCategory;
